import React, { useState, useEffect } from "react";
import { Modal } from "reactstrap";
import { toast } from "react-toastify";
import ApiService from "../../services/apiService";

interface DischargeLineProps {
  isOpen: boolean;
  onClose: () => void;
   container?: HTMLElement | null;
}

const DischargeLine: React.FC<DischargeLineProps> = ({ isOpen, onClose, container }) => {
  const [PumpData, setPumpData] = useState<any[]>([]);

  const getAllPumpingStations = async () => {
    try {
      const response = await ApiService.axiosApi(`/tags`, { method: "GET" });

      if (response.success) {
        
        setPumpData(response.data);
       
      } else {
         console.error("Failed to fetch pumping stations");
      }
    } catch (error) {
      console.error("Error fetching pumping stations:", error);
      
    }
  };

  useEffect(() => {
    getAllPumpingStations();
  
    // Move setInterval inside useEffect
    const interval = setInterval(() => {
      getAllPumpingStations();
    }, 5000); 
  
    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []); // keep dependency array
  
  

  return (
    <Modal isOpen={isOpen} size="md" centered toggle={onClose}
      style={{
        zIndex: 9999, // High z-index
      }}
       container={container || document.body} // Use container prop or fallback to body
        
      modalClassName="custom-modal-class"
        backdropClassName="custom-backdrop-class"
        contentClassName="custom-content-class">
      <div className="panel-discharge">
        {/* Header */}
        <div className="panel-header-discharge">
          <span>DISCHARGE LINE PT</span>
          <div className="icons-discharge">
            <button className="refreshButtonDischargeLine"
              onClick={getAllPumpingStations}
              style={{ cursor: "pointer" }}
            >
              &#x21bb;
            </button>
            <button className='closeDischargeLine'onClick={onClose}>&times;</button>
          </div>
        </div>

        {/* Body */}
        <div className="panel-body-discharge">


<div className="status-box">
  <div className="status-item">
    <span
      className="status-box-pumps"
      style={{
        backgroundColor: PumpData.find(
          t => t.name === "PMP1_PT_HH" && t.value === "True"
        )
          ? "green"
          : "grey",
      }}
    ></span>
    <span className="status-label">PT HH (High High)</span>
  </div>

  <div className="status-item">
    <span
      className="status-box-pumps"
      style={{
        backgroundColor: PumpData.find(
          t => t.name === "PMP1_PT_TRP" && t.value === "True"
        )
          ? "yellow"
          : "grey",
      }}
    ></span>
    <span className="status-label">PT TRP (Trip)</span>
  </div>
</div>

<div className="Dischargetable-div">

          <table className="discharge-table">
           
            <tbody>
            
              <tr>
                <td>PT VALUE</td>
                <td>
                  {PumpData.find(tag => tag.name === "MAIN_HL_PT_VAL")?.value ??
                    "Empty"}{" "}
                  Bar
                </td>
              </tr>
              <tr>
                <td>PUMP HIGH HIGH SETPOINT</td>
                <td>
                  {PumpData.find(tag => tag.name === "HL_PT_HSP")?.value ??
                    "Empty"}
                </td>
              </tr>
              <tr>
                <td>PUMP TRIP SET POINT</td>
                <td>
                  {PumpData.find(tag => tag.name === "HL_PT_TRP_SP")?.value ??
                    "Empty"}
                </td>
              </tr>
              <tr>
                <td>MIN RANGE:</td>
                <td>
                  {PumpData.find(tag => tag.name === "HL_PT_MINRANGE")
                    ?.value ?? "Empty"}
                </td>
              </tr>
              <tr>
                <td>MAX RANGE</td>
                <td>
                  {PumpData.find(tag => tag.name === "HL_PT_MAXRANGE")
                    ?.value ?? "Empty"}
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DischargeLine;
